import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { omit } from 'lodash';
export const isClientFacing = (field)=>field.visibility === 'client_facing';
export const toInput = (field)=>({
        id: field.id,
        name: field.name.trim(),
        value: field.value.trim(),
        visibility: field.visibility,
        copyToInvoices: field.copyToInvoices
    });
export const cloneForDuplicate = (fields)=>fields.map((field)=>omit(toInput(field), 'id'));
export const withDisplayIds = (rows)=>rows.map((row, index)=>{
        var _row_id;
        return _object_spread_props(_object_spread({}, row), {
            id: (_row_id = row.id) !== null && _row_id !== void 0 ? _row_id : "unsaved-".concat(index)
        });
    });
export const toRecordReferenceFieldInputs = (rows)=>rows.map((param)=>{
        let { id, name, value } = param;
        return _object_spread_props(_object_spread({}, id != null && {
            id
        }), {
            name: name.trim(),
            value: value.trim()
        });
    }).filter((param)=>{
        let { name, value } = param;
        return name !== '' || value !== '';
    });
